module.exports = __webpack_public_path__ + "media/locales/_es-fed7d0ce.png";